import React from 'react';

import { TextField } from '@mui/material';
import Joi from 'joi';
import _ from 'lodash';

import { OhsFormFieldBaseProps } from '../services/OhsFormModels';
import OhsFormFieldLayout from '../components/OhsFormFieldLayout';
import { returnFieldStyle, returnVariant } from '../components/OhsFieldLayout';

export interface Props extends OhsFormFieldBaseProps {}

function InputEle(props: Props) {
  const error = _.get(props.ohsFormSettings.useFormMethods.formState.errors, props.id);
  return (
    <TextField
      id={props.id}
      type="url"
      error={error != null}
      fullWidth
      margin="dense"
      InputLabelProps={{
        shrink: true,
      }}
      size="small"
      variant={returnVariant(props.ohsFormSettings.layout)}
      required={props.required}
      disabled={props.disabled}
      inputProps={{ 'data-testid': props.id }}
      {...props.ohsFormSettings.useFormMethods.register(props.id, {
        required: props.required,
        validate: {
          isURL: (valueURL: string) => {
            if (props.required !== true && _.isEmpty(valueURL)) {
              return true;
            }
            const schema = Joi.object({
              valueURL: Joi.string().uri(),
            });
            const schemaValidation = schema.validate({ valueURL });
            const schemaError = schemaValidation.error;
            if (_.isUndefined(schemaError) || _.isNil(schemaError)) {
              return true;
            }
            return false;
          },
        },
      })}
      style={returnFieldStyle(props.ohsFormSettings.layout)}
    />
  );
}

export default function OhsUrlField(props: Props) {
  return <OhsFormFieldLayout {...props} inputEle={<InputEle {...props} />} />;
}
